import { defineMessages } from "react-intl";

const AFFILIATIONS_LIST_ITEM = "affiliations-list-item";

const affiliationListItemMessages = defineMessages({
  validAffiliation: {
    id: `${AFFILIATIONS_LIST_ITEM}.valid-affiliation`,
    defaultMessage: "Valid until {formattedDate}"
  },
  expiredAffiliation: {
    id: `${AFFILIATIONS_LIST_ITEM}.expired-affiliation`,
    defaultMessage: "Expired {formattedDate}"
  },
  reauthorizeAffiliation: {
    id: `${AFFILIATIONS_LIST_ITEM}.reauthorize-affiliation`,
    defaultMessage: "Must reauthorize"
  }
});

export default affiliationListItemMessages;
